export default class {
  constructor(el) {
    this.dom = {el: el};
    this.dom.aside = this.dom.el.querySelector('.l-floatingnav__aside');
    this.dom.sections = this.dom.el.querySelectorAll('[data-floatingnav-section]');
    this.dom.navA = this.dom.el.querySelectorAll('.c-floatingnav__link');

    this.io = undefined;
    this.currentSection = 0;

    this.check = this.check.bind(this);

    this.init();
  }

  init() {

    // セクションにインデックス番号を付与
    this.dom.sections.forEach((el, i) => {
      el.dataset.floatingnavIndex = i;
    });

    // io
    const options = {
      root: null,
      rootMargin: "-50% 0px",
      threshold: 0,
    };
    this.io = new IntersectionObserver(this.check, options);
    this.dom.sections.forEach(el => this.io.observe(el));
  }

  check(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        this.setCurrent(entry.target.dataset.floatingnavIndex);
      }
    });
  }

  setCurrent(n) {
    this.dom.navA[this.currentSection].classList.remove('is-active');
    this.dom.navA[n].classList.add('is-active');
    this.currentSection = n;
  }
}
